export default "__VITE_ASSET__Bj3eJFfx__"